// extracted by mini-css-extract-plugin
export default {"container":"uP-z","title":"vP-z","link":"wP-z"};